import { TrainingStep } from "../../components/common/TrainingGuide";

const pricingSteps: TrainingStep[] = [
  {
    title: "Price Intelligence Overview",
    description:
      "The pricing module uses AI (Ollama → DeepSeek) to suggest optimal prices for ENZO Italy and Lizze Professional products based on competitor data scraped from noon, Amazon, and Trendyol.",
    tip: "This is exclusive to ENZO and LIZZE — do not share pricing insights with third-party sellers.",
  },
  {
    title: "Running a Price Scan",
    description:
      "Click 'Run Scan' to trigger a competitor scrape. The system checks noon.com, Amazon.ae, and Trendyol.com for matching SKUs and records their current prices. Scan takes 30–90 seconds.",
    tip: "Scans run automatically at 10:30 AM daily (Dubai time). Manual scans are for on-demand checks.",
  },
  {
    title: "Reading Score Donuts",
    description:
      "Each product card has a score donut showing competitiveness 0–100. Green (70+) = priced well. Amber (40–69) = review suggested. Red (below 40) = uncompetitive — action required.",
    tip: "A low score doesn't always mean lower your price. Sometimes it means competitors are undercutting and you should hold for quality positioning.",
  },
  {
    title: "Brand Leverage",
    description:
      "ENZO Italy and Lizze Professional carry premium brand equity. The AI factors in a 'brand leverage' score that allows higher prices than pure competitors. This is why our suggested prices are often above the market average.",
    tip: "LIZZE has the highest leverage score because AFAQ is the exclusive brand owner — no one else can sell it.",
  },
  {
    title: "Applying Price Suggestions",
    description:
      "Click 'Apply' on any suggestion to push the new price directly to Shopify via the Admin API. Changes go live within minutes. You can also 'Reject' to keep the current price and add a note for the record.",
    tip: "Always cross-check with inventory before applying a price drop — limited stock + low price = lost margin.",
  },
];

export default pricingSteps;
